import React, { createContext, useContext, useState, useEffect } from "react";
import { useLab } from "./PharmacyProvider";

const CurrencyContext = createContext();

export const CurrencyProvider = ({ children }) => {
  const { currentLab } = useLab();
  const [currency, setCurrency] = useState(null);
  const exchangeRates = { INR: 1, USD: 0.012, EUR: 0.011 };

  // Set default currency from allowedCurrencies after provider initializes
  useEffect(() => {
    // console.log(currentLab)
    if (currentLab?.allowedCurrencies?.length > 0) {
      // setCurrency(currentLab?.allowedCurrencies[0]);
      setCurrency(currentLab?.baseCurrency);
    }
  }, [currentLab]);

  const getCurrencySymbol = (code = null, position = "prefix") => {
    const selectedCode =
      code ||
      currency ||
      currentLab?.allowedCurrencies?.[0] ||
      "INR";

    try {
      const formatter = new Intl.NumberFormat(undefined, {
        style: "currency",
        currency: selectedCode,
        currencyDisplay: "symbol",
      });

      // Extract only the symbol
      const parts = formatter.formatToParts(0);
      const symbol = parts.find(p => p.type === "currency")?.value || selectedCode;

      return position === "suffix" ? ` ${symbol}` : symbol;
    } catch (err) {
      // Fallback (VERY rare case)
      return position === "suffix" ? ` ${selectedCode}` : selectedCode;
    }
  };

 const convertCurrency = (amount, fromCurrency, toCurrency) => {
    if (!amount || fromCurrency === toCurrency) return amount;
 
    const rates = currentLab?.conversionRates || {};
    const baseCurr = currentLab?.baseCurrency || "INR";
    const allRates = { ...rates, [baseCurr]: 1 };

    if (!allRates[fromCurrency] || !allRates[toCurrency]) {
      return amount;
    }
 
    // Step 1: Convert FROM currency → baseCurrency
    const amountInBase = amount / allRates[fromCurrency];    
    // Step 2: Convert baseCurrency → TO currency
    const convertedAmount = amountInBase * allRates[toCurrency];
    return convertedAmount
    // return Number(convertedAmount.toFixed(2));
  };


  return (
    <CurrencyContext.Provider value={{ currency, setCurrency, getCurrencySymbol, allowedCurrencies: currentLab?.allowedCurrencies || [], convertCurrency }}>
      {children}
    </CurrencyContext.Provider>
  );
};

export const useCurrency = () => useContext(CurrencyContext);